import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import './App.css';
import { ToastContainer } from 'react-toastify';

import HomeView from './dynatables/components/HomeView';
import HelpView from './dynatables/components/HelpView';

import IndexView from './wizard/components/IndexView';
import InstallView from './wizard/components/InstallView';
import FinishView from './wizard/components/FinishView';

class App extends Component {
    render() {
        return (
            <div className="App full-height">
                <ToastContainer autoClose={false} />
                <Switch>
                    <Route exact path="/" component={IndexView} />
                    {/* <Route path="/configuration" component={ConfigurationView} /> */}
                    <Route path="/home" component={HomeView} />
                    <Route path="/index" component={IndexView} />
                    <Route path="/install" component={InstallView} />
                    <Route path="/help" component={HelpView} />
                    <Route path="/finish/:errorMessage?" component={FinishView} />
                    <Route component={IndexView} />
                </Switch>
            </div>
        );
    }
}

export default withRouter(App);